import React from "react";
import { bool, func, object } from "prop-types";
import { Col, FormControl,FormGroup, Modal, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { hideModal, removeModal } from "../../../redux/ducks/modals";
import { denyRequest } from '../api';

  class DenyReason extends React.Component {
    constructor(props)
    {
      super(props)    
      this.state = {
        reason: '',
        saveReason: false,
      }
      this.handleDenyReason = this.handleDenyReason.bind(this);
      this.handleReasonChange = this.handleReasonChange.bind(this);
    }
    handleDenyReason() {
      const { reason } = this.state;
      const token = this.props.oidc.user.access_token;
      const userRequestId = 45;
      denyRequest(userRequestId,reason,token).then((response) => {
        console.log('DenyResponse', response)
        this.props.handleHideModal();
      })
    }
    handleReasonChange(evt) {
       const reason = evt.target.value;
       this.setState({ reason });
    }
    render()
    {
    const { reason, saveReason } = this.state;
    const iconStyle = saveReason === true ? "fa fa-spinner fa-spin":"fa fa-times-circle"
    return (<Modal
      show={this.props.show}
      onHide={this.props.handleHideModal}
      onExited={this.props.handleRemoveModal}
      backdropClassName="modal-backdrop"
      // className="asset-modal"
    >
      <div>
        <Modal.Header closeButton>
          <Modal.Title>Deny Access Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form-horizontal">
            <FormGroup>
              <label className="col-sm-1 col-lg-1 control-label">Reason</label>{'    '}
              <Col sm={ 11 } md={11}>
                <FormControl type="text" name="denyreason" id="denyreason" onChange={this.handleReasonChange} value={reason} className="form-control" />
              </Col>
            </FormGroup>
          </form>
        </Modal.Body> 
        <Modal.Footer>
          <Button onClick={this.props.handleHideModal} bsStyle="default">
            Cancel
          </Button>
          <Button bsStyle="danger" onClick={this.handleDenyReason} disabled={reason.length === 0}>
            <i className={iconStyle} aria-hidden="true"/>&nbsp;&nbsp;Deny Request
          </Button>
        </Modal.Footer>
      </div>
    </Modal>)
  }
}

DenyReason.propTypes = {
  show: bool,
  handleHideModal: func,
  handleRemoveModal: func,
  oidc: object,
};

const mapDispatchToProps = dispatch => ({
  handleHideModal: () => {
    dispatch(hideModal("DENY_REASON"));
  },
  handleRemoveModal: () => {
    dispatch(removeModal("DENY_REASON"));
  },
});
const mapStateToProps = ({  oidc }) => {
	return {
		oidc: { ...oidc },
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(DenyReason);



// WEBPACK FOOTER //
// ./src/components/userSearchResults/modals/denyreason-container.js